import { z } from "zod/v4";

/**
 * Token data for a password-protected document.
 * Stored in-memory only (not persisted to localStorage).
 */
export const DocumentTokenSchema = z.object({
	accessToken: z.string(),
	refreshToken: z.string().optional(),
	/** Unix timestamp (milliseconds) when the access token expires */
	expiresAt: z.number(),
	documentId: z.string(),
	workspaceId: z.string(),
});

export type DocumentToken = z.infer<typeof DocumentTokenSchema>;

/**
 * Response from the backend password exchange endpoint.
 * Matches the Auth0 TokenSet structure.
 */
export interface PasswordExchangeResponse {
	access_token: string;
	refresh_token?: string;
	expires_in: number;
	token_type?: string;
	scope?: string;
}
